/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Scan_Crop_FailedInputs */

const en_mobile_scan_crop_failed = /** @type {(inputs: Mobile_Scan_Crop_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not crop page`)
};

const es_mobile_scan_crop_failed = /** @type {(inputs: Mobile_Scan_Crop_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo recortar la página`)
};

/**
* | output |
* | --- |
* | "Could not crop page" |
*
* @param {Mobile_Scan_Crop_FailedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_scan_crop_failed = /** @type {((inputs?: Mobile_Scan_Crop_FailedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Scan_Crop_FailedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_scan_crop_failed(inputs)
	return en_mobile_scan_crop_failed(inputs)
});